import React from "react";
import { Icon } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import styles from "./CustomerNotes.module.scss";

interface ICustomerNotesProps {
  notes: string[];
}

const CustomerNotes: React.FC<ICustomerNotesProps> = ({ notes }) => {
  if (!notes || notes.length === 0) {
    return null;
  }

  return (
    <div className={styles.notesSection}>
      <p><b>Notes:</b></p>
      <div className={styles.notesContainer}>
        {[...notes].reverse().map((note, index) => (
          <div key={index} className={styles.noteItem}>
            <Icon icon={IconNames.CLIPBOARD} size={12} className={styles.noteIcon} />
            <span>{note}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerNotes;
